import {Box, useFoundationTheme} from 'platform/foundation';

import {useId} from 'react';

export function MyDayOrb() {
  const id = useId();
  const theme = useFoundationTheme();

  return (
    <Box width={13} height={13} flexShrink={0}>
      <svg viewBox="0 0 64 64" width="100%" height="100%" aria-hidden>
        <defs>
          <radialGradient id={`${id}-body`} cx="28%" cy="24%" r="80%">
            <stop offset="0" stopColor={theme.colors.palettes.teal[40][100]} />
            <stop offset="0.3" stopColor={theme.colors.palettes.blue[50][100]} />
            <stop offset="0.65" stopColor={theme.colors.palettes.purple[60][100]} />
            <stop offset="1" stopColor={theme.colors.palettes.purple[90][100]} />
          </radialGradient>
          <radialGradient id={`${id}-light`}>
            <stop offset="0" stopColor={theme.colors.general.white} stopOpacity="0.85" />
            <stop offset="1" stopColor={theme.colors.general.white} stopOpacity="0" />
          </radialGradient>
          <radialGradient id={`${id}-halo`}>
            <stop
              offset="0.5"
              stopColor={theme.colors.palettes.purple[50][100]}
              stopOpacity="0.25"
            />
            <stop offset="1" stopColor={theme.colors.palettes.purple[50][100]} stopOpacity="0" />
          </radialGradient>
        </defs>
        <circle cx="32" cy="35" r="31" fill={`url(#${id}-halo)`} />
        <circle cx="32" cy="30" r="23" fill={`url(#${id}-body)`} />
        <ellipse cx="24" cy="21" rx="12" ry="10" fill={`url(#${id}-light)`} />
      </svg>
    </Box>
  );
}
